import { DividerOrientation } from '@/components';
import { cn } from '@/lib/utils';
import { useActionBarResponsiveClasses } from './useActionBarResponsiveClasses';

interface ActionBarDividerProps {
    orientation?: DividerOrientation;
}

export function ActionBarDivider({
    orientation = DividerOrientation.HORIZONTAL,
}: ActionBarDividerProps) {
    const responsive = useActionBarResponsiveClasses();
    if (orientation === DividerOrientation.VERTICAL) {
        return (
            <div
                className={cn(
                    'w-px h-[14px] bg-grey-300 ml-0.5 shrink-0',
                    responsive.dividerMargin,
                )}
            />
        );
    }
    return <div className="h-px bg-grey-500 my-1" />;
}
